/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Modal')
    .directive('accConfirm', ['confirmAction', function(confirm){
        return {
            link: function ($scope, $element, attrs) {
                var
                    callback = attrs['accConfirm'];

                $element.on('click', function () {
                    confirm($scope, attrs).then(function(){
                        $scope.$eval(callback);
                    });
                });
            }
        }
    }]);
 
 
